import React from 'react';
import Modal from '../common/Modal.jsx';
import FormularioDocumentacion from './FormularioDocumentacion';

// Modal reutilizable para alta/edicion de documentacion.
// Mantiene la misma configuracion visual/funcional de la lista general.
const ModalDocumentacion = ({
  isOpen,
  onClose,
  onSaved,
  documento = null,
  initialEquipo = null,
}) => {
  const handleSave = async (savedData, opts = {}) => {
    if (typeof onSaved === 'function') {
      await onSaved();
    }
    if (opts.keepOpen) return; // "Guardar y nuevo/duplicar": el modal se queda abierto
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const handleCancel = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      title={documento ? 'Editar Documento' : 'Nuevo Documento'}
      size="lg"
    >
      <FormularioDocumentacion
        documento={documento || undefined}
        initialEquipo={documento ? undefined : initialEquipo}
        onSave={handleSave}
        onCancel={handleCancel}
        showTitle={false}
        compact
        enableSaveAndNew={!documento}
      />
    </Modal>
  );
};

export default ModalDocumentacion;
